import React from "react";
import api from "../../../../services/api";
import { CreatEditAtividade } from "./CreateEdit";
export default function AdminAtividades(props) {
  let activities = props.activities;
  let setActivities = props.setActivities;
  let checkpoints = props.checkpoints;
  let showFlash = props.showFlash;
  let editingActivity = props.editingActivity;
  let setEditingActivity = props.setEditingActivity;
  const ord = [...activities].sort(
    (left, right) => left.ordem - right.ordem || left.id - right.id,
  );
  return (
    <div>
      <div
        className={"fl2 in"}
        style={{
          marginBottom: 12,
          fontSize: 12,
        }}
      >
        {
          "Cada atividade tem pontos de ranking (pontos) e tokens separados. Configure os limites que o sistema vai enforcar automaticamente."
        }
      </div>
      <div className={"ga"}>
        <div
          style={{
            overflowX: "auto",
          }}
        >
          <table className={"tbl"}>
            <thead>
              <tr>
                <th>{"#"}</th>
                <th>{"Atividade"}</th>
                <th>{"Rank/un."}</th>
                <th>{"Tok/un."}</th>
                <th>{"Max token"}</th>
                <th>{"Max pts"}</th>
                <th>{"Status"}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {ord.map((ordOrdem) => (
                <tr key={ordOrdem.id}>
                  <td
                    style={{
                      color: "#B8C5CC",
                    }}
                  >
                    {ordOrdem.ordem}
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          background: ordOrdem.cor,
                          display: "inline-block",
                        }}
                      />
                      <div>
                        <div
                          style={{
                            fontWeight: 700,
                            fontSize: 12,
                          }}
                        >
                          {ordOrdem.nome}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            color: "#6B8590",
                          }}
                        >
                          {ordOrdem.unidade}
                          {"/"}
                          {ordOrdem.periodo || "dia"}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: "#FF8C42",
                      }}
                    >
                      {ordOrdem.ppu_rank}
                    </span>
                  </td>
                  <td>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: "#4FB3A9",
                      }}
                    >
                      {ordOrdem.ppu_token}
                    </span>
                  </td>
                  <td
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {ordOrdem.max_token || (
                      <span
                        style={{
                          color: "#C7C2B6",
                        }}
                      >
                        {"-"}
                      </span>
                    )}
                  </td>
                  <td
                    style={{
                      fontSize: 12,
                    }}
                  >
                    {ordOrdem.max_pts || (
                      <span
                        style={{
                          color: "#C7C2B6",
                        }}
                      >
                        {"-"}
                      </span>
                    )}
                  </td>
                  <td>
                    <span
                      className={"bst ".concat(ordOrdem.ativo ? "bon" : "bof")}
                    >
                      {ordOrdem.ativo ? "Ativo" : "Inativo"}
                    </span>
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <button
                      className={"btn bg bs"}
                      style={{
                        marginRight: 4,
                      }}
                      onClick={() => setEditingActivity(ordOrdem.id)}
                    >
                      {"Editar"}
                    </button>
                    <button
                      className={"btn bd bs"}
                      onClick={() =>
                        ((item) => {
                          (async () => {
                            if (
                              checkpoints.some((checkpoint) =>
                                checkpoint.itens.some(
                                  (iten) => iten.tipo_id === item.id,
                                ),
                              )
                            )
                              showFlash("Já usada. Desative.", "er");
                            else
                              try {
                                await api.delete(
                                  "/activities?id=".concat(item.id),
                                );
                                setActivities(
                                  activities.filter(
                                    (activity) => activity.id !== item.id,
                                  ),
                                );
                                showFlash("Excluida.");
                              } catch (err) {
                                showFlash(
                                  err.response?.data?.message ||
                                    "Nao foi possivel excluir a atividade.",
                                  "er",
                                );
                              }
                          })();
                        })(ordOrdem)
                      }
                    >
                      {"X"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <CreatEditAtividade
          editingActivity={editingActivity}
          activities={activities}
          setActivities={setActivities}
          showFlash={showFlash}
          setEditingActivity={setEditingActivity}
        />
      </div>
    </div>
  );
}
export { AdminAtividades };
